module.exports = __webpack_public_path__ + "img/pup-dash-header.42a7bcf7.jpg";